import type { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface DialogBodyProps extends ComponentProps<'div'> {
  /** Styles the inner scroll container — the only way to change the body's padding. */
  contentClassName?: string
}

/** Scrolls when tall. Sits 20px above the footer; as the last part it carries the popup's 24px bottom padding. */
export function DialogBody({ className, contentClassName, children }: DialogBodyProps) {
  return (
    <div className={twMerge('group/body flex h-full max-h-[700px] min-h-0 flex-grow', className)}>
      <div className={twMerge('w-full space-y-3 overflow-y-auto px-6 pb-5 group-last/body:pb-6', contentClassName)}>
        {children}
      </div>
    </div>
  )
}
